import { ReactElement } from "react";

export const STICKY_BLOCK_SIZE = 132;
export const MAX_ITEMS_COUNT_FOR_SCROLL = 8;
export const SCROLL_ITEMS_NAME = 'notification-item';
export const DEFAULT_DROPDOWN_HEIGHT = 484;

export enum NotificationTypes {
    LIKE = 'like',
    BOOK = 'book',
    SIMPLE = 'simple',
    LMS_HOMEWORK_COMMENT = 'lms_hw_comment',
    COAUTHOR_ADD = 'prj_coauthor_add',
    COAUTHOR_REMOVE = 'prj_coauthor_remove',
    EXAM_RESULT = 'lms_exam_result',
    LMS_HOMEWORK_APPROVE = 'lms_hw_approve',
    LMS_HOMEWORK_ADD = 'lms_hw_add',
    SEND_FILE = 'sendFile',
    AUTO_TRANSLATION_COMPLETE_PRJ = 'prj_auto_translation_complete',
    NEW_PROMO_CODE_RECIEVED = 'new_promo_code_recieved',
    COMPETITION_APPLY_RESULT_RECIEVED = 'competition_apply_result_recieved',
    LMS_LESSON_SCHEDULED = 'lms_lesson_scheduled',
    LMS_EXAM_SCHEDULED = 'lms_exam_scheduled',
    CERTIFICATION_OPERATION = 'certification_operation',
    channel_comment = 'channel_comment',
    channel_like = 'channel_like',
    channel_member_add = 'channel_member_add',
    channel_member_remove = 'channel_member_remove',
    channel_archive = 'channel_archive',
    PROJECT_BANNED = 'project_banned',
    GENERATION = 'AIGeneration',
    TEAM_STATUS_CHANGE = 'team_moder_status_change',
    EXTERNAL_TEAM_CREATED = 'team_owner_status_change'
}

export interface INotificationComponent {
    component: ReactElement | null;
    withoutDate?: boolean;
}import { ReactElement } from "react";

export const STICKY_BLOCK_SIZE = 132;
export const MAX_ITEMS_COUNT_FOR_SCROLL = 8;
export const SCROLL_ITEMS_NAME = 'notification-item';
export const DEFAULT_DROPDOWN_HEIGHT = 484;

export enum NotificationTypes {
    LIKE = 'like',
    BOOK = 'book',
    SIMPLE = 'simple',
    LMS_HOMEWORK_COMMENT = 'lms_hw_comment',
    COAUTHOR_ADD = 'prj_coauthor_add',
    COAUTHOR_REMOVE = 'prj_coauthor_remove',
    EXAM_RESULT = 'lms_exam_result',
    LMS_HOMEWORK_APPROVE = 'lms_hw_approve',
    LMS_HOMEWORK_ADD = 'lms_hw_add',
    SEND_FILE = 'sendFile',
    AUTO_TRANSLATION_COMPLETE_PRJ = 'prj_auto_translation_complete',
    NEW_PROMO_CODE_RECIEVED = 'new_promo_code_recieved',
    COMPETITION_APPLY_RESULT_RECIEVED = 'competition_apply_result_recieved',
    LMS_LESSON_SCHEDULED = 'lms_lesson_scheduled',
    LMS_EXAM_SCHEDULED = 'lms_exam_scheduled',
    CERTIFICATION_OPERATION = 'certification_operation',
    channel_comment = 'channel_comment',
    channel_like = 'channel_like',
    channel_member_add = 'channel_member_add',
    channel_member_remove = 'channel_member_remove',
    channel_archive = 'channel_archive',
    PROJECT_BANNED = 'project_banned',
    GENERATION = 'AIGeneration',
    TEAM_STATUS_CHANGE = 'team_moder_status_change',
    EXTERNAL_TEAM_CREATED = 'team_owner_status_change'
}

export interface INotificationComponent {
    component: ReactElement | null;
    withoutDate?: boolean;
}